import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { Checkbox } from 'design-system/src/components/Checkbox/Checkbox';
import { getAttestationCopy } from './attestationConfig';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px;
  background-color: var(--grayscale-50);
  border-bottom: 1px solid var(--grayscale-100);
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-left: 16px;
`;

const StyledCheckbox = styled(Checkbox)`
  margin: -9px 0 0 -9px !important;
  padding-right: 12px !important;
`;

export type ProviderAttestationBannerProps = {
  drugName: string | null;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

/**
 * Banner displaying provider attestation checkbox for patient consent.
 * Only shown for Prescriber role when supports_provider_attestation is true.
 */
export function ProviderAttestationBanner({ drugName, checked, onChange }: ProviderAttestationBannerProps) {
  const attestationCopy = getAttestationCopy(drugName);

  if (!attestationCopy) {
    return null;
  }

  return (
    <Container>
      <Typography styledAs="bodySmallDMSans">
        <strong>{attestationCopy.headerPrefix}</strong> {attestationCopy.headerText}
      </Typography>
      <CheckboxContainer>
        <StyledCheckbox checked={checked} onChange={() => onChange(!checked)} />
        <Typography styledAs="bodySmallDMSans">{attestationCopy.checkboxLabel}</Typography>
      </CheckboxContainer>
    </Container>
  );
}
